import { USD_MOCK_TOKEN } from '@/domain/types/Token'
import { TxOverviewRouteItem } from '@/features/dialogs/common/types'
import { assets } from '@/ui/assets'
import { cn } from '@/ui/utils/style'
import { testIds } from '@/ui/utils/testIds'

export interface RouteItemProps {
  item: TxOverviewRouteItem
  index: number
  isLast: boolean
  displayRouteVertically: boolean
}
export function RouteItem({ item, index, isLast, displayRouteVertically }: RouteItemProps) {
  return (
    <div
      className={cn(
        'grid grid-cols-1 items-center gap-x-2 gap-y-0.5',
        !isLast && !displayRouteVertically && 'md:grid-cols-[auto_auto]',
      )}
    >
      <div data-testid={testIds.dialog.transactionOverview.routeItem.tokenWithAmount(index)}>
        {item.token.format(item.value, { style: 'auto' })} {item.token.symbol}
      </div>
      <div
        className={cn('justify-self-end text-basics-dark-grey text-sm', !displayRouteVertically && 'md:order-last')}
        data-testid={testIds.dialog.transactionOverview.routeItem.tokenUsdValue(index)}
      >
        {USD_MOCK_TOKEN.formatUSD(item.usdValue)}
      </div>
      {!isLast && (
        <img
          src={assets.arrowRight}
          className={cn(
            'mt-1.5 h-3.5 w-3.5 rotate-90 justify-self-end',
            !displayRouteVertically && 'md:mt-0 md:rotate-0',
          )}
        />
      )}
    </div>
  )
}
